var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlibaba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206.3,
    height: 206.3,
    viewBox: "0 0 54.584 54.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.458 -5.244)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -291.344 -254.454)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h2050v594H-1z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff6a00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1201.392 1127.833l-46.4-10.1c-4.2-1-7.4-4.7-7.6-9.2v-50c.2-4.5 3.4-8.2 7.6-9.2l46.4-10.1 5-19.7h-54c-19 0-34.3 15.3-34.4 34.3v59.2c0 19.1 15.4 34.5 34.3 34.5h54zm39.5 0l46.4-10.1c4.2-1 7.4-4.7 7.6-9.2v-50c-.2-4.5-3.4-8.2-7.6-9.2l-46.4-10.1-5-19.7h54c19 0 34.3 15.3 34.4 34.3v59.2c-.1 18.9-15.4 34.3-34.4 34.3h-54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.392 1081.133h39.5v4.9h-39.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlibaba);
export default __webpack_public_path__ + "static/media/alibaba.c9873b86076c06827747fdef710f9a9e.svg";
export { ForwardRef as ReactComponent };